import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import "../../assets/css/forgetpassword.css"
import { changeforgotPassword } from "../../api/forgetpassword";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { userForgetPassword } from "../../store/actions";
import FullScreenLoader from "../../components/Common/Loader";
import CommonToastContainer from "../../components/Common/CommonToastContainer";

const ForgetPasswordPage = props => {
	const dispatch = useDispatch();
	document.title = "Forget Password";

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [showLoader, setShowLoader] = useState(false);
	const [toasts, setToasts] = useState([]);

	const showToast = (toastData) => {
		setToasts((prev) => [...prev, { id: Date.now(), ...toastData }]);
	};

	const removeToast = (id) => {
		setToasts((prev) => prev.filter((t) => t.id !== id));
	};

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: '',
		},
		validationSchema: Yup.object({
			email: Yup.string().required("Please Enter Your Email"),
		}),
		onSubmit: async (values) => {
			setShowLoader(true);
			setError(null);
			try {
				const requestData = {
					Email: values.email,
				};
				const response = await changeforgotPassword(requestData);
				if (response?.Message?.[0]?.RETURNCODE === "1") {
					showToast({
						title: "Success!",
						message: response?.Message?.[0]?.RETURNMESSAGE || "Reset Passwort Successfully!",
						type: "success",
					});
				}
				else {
					console.log(response);
					showToast({
						title: "Error!",
						message: response?.Message?.[0]?.RETURNMESSAGE || "Failed to reset password!",
						type: "error",
					});
				}
				dispatch(userForgetPassword({ email: values.email }, props.router.navigate));

			} catch (err) {
				console.error("Error sending forgot password request:", err);
				showToast({
					title: "Error!",
					message: "Failed to send reset link. Please try again.",
					type: "error",
				});
			} finally {
				setShowLoader(false);
			}
		}
	});

	const forgetpass = createSelector(
		(state) => state.forgetPassword,
		(layout) => ({
			forgetSuccessMsg: layout.forgetSuccessMsg,
		})
	);

	const { forgetSuccessMsg, forgetError } = useSelector(forgetpass);

	return (
		<>
			<div
				className="bg-pattern d-flex flex-column"
				style={{
					backgroundImage: `linear-gradient(rgba(0,0,0,.20), rgba(0,0,0,.20)), url(/assets/images/backgroundImages/bg4.png)`,
					backgroundSize: "cover",
				}}
			>
				{showLoader && <FullScreenLoader />}
				<div className="account-pages flex-grow-1 main-background">
					<Container>
						<Row className="justify-content-center">
							<Col md={8} lg={6} xl={4}>
								<Card className="login-card p-3 mb-0" style={{
									borderRadius: "28px",
									overflow: "hidden",
									backgroundColor: "#ffffff"
								}}>
									<div className="login-banner">
										<img
											src="/assets/images/Logo/Midamas_Logo_2_15.png"
											alt="Midamas"
										/>
									</div>

									<CardBody className="p-0">
										<div className="">
											<div className="text-center mb-4 mt-4">
												<h4 className="fw-bold mb-2">Forgot Password</h4>
												<p className="text-muted mb-4">
													Enter your email and we’ll send you a link to reset your password.
												</p>
											</div>

											{forgetError && (
												<Alert color="danger" style={{ marginTop: "13px" }}>
													{forgetError}
												</Alert>
											)}
											{forgetSuccessMsg && (
												<Alert color="success" style={{ marginTop: "13px" }}>
													{forgetSuccessMsg}
												</Alert>
											)}

											<Form
												className="form-horizontal"
												onSubmit={(e) => {
													e.preventDefault();
													validation.handleSubmit();
													return false;
												}}
											>
												<div className="mb-3">
													<Label className="form-label" htmlFor="forgotMail">Email</Label>
													<Input
														id="forgotMail"
														name="email"
														className="form-control"
														placeholder="Enter email"
														type="email"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														value={validation.values.email || ""}
														invalid={
															validation.touched.email && validation.errors.email ? true : false
														}
													/>
													{validation.touched.email && validation.errors.email ? (
														<FormFeedback type="invalid">
															<div>{validation.errors.email}</div>
														</FormFeedback>
													) : null}
												</div>

												<Row className="button-row">
													<div className="d-grid mt-2">
														<button
															className="btn btn-primary waves-effect waves-light"
															type="submit"
														>
															Reset
														</button>
													</div>
												</Row>
											</Form>
										</div>

										<div className="text-center">
											<p className="forgot-password-p p-0 my-2">
												Go back to{" "}
												<a href="/login" className="login-hover-link font-weight-medium text-primary">
													Login
												</a>{" "}
											</p>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</div>
			<CommonToastContainer toasts={toasts} removeToast={removeToast} />
		</>
	);
};

ForgetPasswordPage.propTypes = {
	history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
